<h2 mat-dialog-title>Reallocate Services</h2>
<mat-dialog-content>
  <div class="dialog-content">
    <p>Reallocate {{serviceCount}} services from {{sourceStaffName}}</p>
    
    <!-- Shift Staff Dropdown -->
    <mat-form-field *ngIf="shiftStaff.length > 0" appearance="fill" class="staff-select">
      <mat-label>Select Shift Staff</mat-label>
      <mat-select [value]="selectedShiftStaff" (selectionChange)="onShiftStaffSelected($event.value)">
        <mat-option *ngFor="let staff of shiftStaff" [value]="staff.key">
          {{staff.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Regular Staff Dropdown -->
    <mat-form-field *ngIf="regularStaff.length > 0" appearance="fill" class="staff-select">
      <mat-label>Select Regular Staff</mat-label>
      <mat-select [value]="selectedRegularStaff" (selectionChange)="onRegularStaffSelected($event.value)">
        <mat-option *ngFor="let staff of regularStaff" [value]="staff.key">
          {{staff.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Message when no staff available -->
    <p *ngIf="shiftStaff.length === 0 && regularStaff.length === 0" class="no-staff-message">
      No available staff members found for reallocation.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="!hasSelection">
    Reallocate
  </button>
</mat-dialog-actions>
